

/// <reference path="OnlineItem.ts" />

// Generated class OnlineMenu_ManagedObject

class OnlineMenu_ManagedObject extends OnlineItem
{
    // Relationship: menu
    set menu(value:Menu) {
        this.setValueForKey(value, 'menu');
    }
    get menu():Menu {
        return this.valueForKey('menu') as Menu;
    }
}
